<template>
  <v-container fluid id="skill">
    <v-row justify="center" align="center" class="mt-md-16 mt-xs-0">
      <span style="
          font-family: Roboto !important;
          font-size: 600 !important;
          color: var(--var2);
        " class="text-h6 text-sm-h6 text-md-h5 text-lg-h4 text-xl-h4 mb-8">Skill</span>
    </v-row>
    <v-row align="center" justify="center" class="mb-8">
      <v-col cols="12" md="4">
        <div class="skills-circle-wrap">
          <div class="skills-circle">
            <div class="skill-orbit" v-for="(list, index) in skill" :key="index">
              <div class="skill-planet">
                <span>{{ list.name }}</span>
              </div>
            </div>
          </div>
          <div class="skills-top-circle"></div>
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-row>
          <v-col class="logoParent" v-for="(list, index) in skill" :key="index" cols="12" sm="4">
            <div class="text-subtitle-2 text-sm-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-h4">
              <ul>
                <li>
                  <v-row align="center" justify="center">
                    <v-col cols="3" md="4">
                      <span class="logoExplainLeft mr-2">{{ list.name }}</span>
                    </v-col>
                    <v-col cols="9" md="8">{{ list.explain }}</v-col>
                  </v-row>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.skills-circle-wrap {
  width: 300px;
  height: 300px;
  position: relative;
  margin: 10px auto;
  pointer-events: fill;
  cursor: pointer;
  -webkit-transform: perspective(900px);
  transform: perspective(900px);
}

.skills-top-circle {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--var2);
  box-shadow: 0 0 50px #0011ff;
}

.skills-circle {
  width: 300px;
  height: 300px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  transition: 3s all;
}

.skill-orbit {
  border: 1px solid var(--var1);
  border-radius: 50%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: 3s all;
  transform: perspective(900px);
  animation: ColorChange 15s infinite;
}

.skill-planet {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: absolute;
  top: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-family: Arial;
  font-weight: 100;
  text-align: center;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  transition: 1s all;
}

.skill-planet span {
  display: block;
}

@keyframes ColorChange {
  0% {
    border: 1px solid var(--var1);
  }

  25% {
    border: 1px solid var(--var2);
  }

  50% {
    border: 1px solid var(--var3);
  }

  75% {
    border: 1px solid var(--var5);
  }

  100% {
    border: 1px solid var(--var6);
  }
}

.skill-orbit:nth-child(1) {
  width: 100%;
  height: 100%;
}

.skill-orbit:nth-child(2) {
  width: 82.5%;
  height: 82.5%;
}

.skill-orbit:nth-child(3) {
  width: 82.5%;
  height: 82.5%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(4) {
  width: 82.5%;
  height: 82.5%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(5) {
  width: 82.5%;
  height: 82.5%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(6) {
  width: 82.5%;
  height: 82.5%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(7) {
  width: 65%;
  height: 65%;
}

.skill-orbit:nth-child(8) {
  width: 65%;
  height: 65%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(9) {
  width: 47.5%;
  height: 47.5%;
}

.skill-orbit:nth-child(10) {
  width: 47.5%;
  height: 47.5%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(11) {
  width: 30%;
  height: 30%;
}

.skill-orbit:nth-child(12) {
  width: 30%;
  height: 30%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(13) {
  width: 30%;
  height: 30%;
  border: 1px solid transparent !important;
}

.skill-orbit:nth-child(1) .skill-planet {
  background: #000000;
  border: 2px solid #0d2534;
  color: #ffffff;
  font-size: 7px;
  line-height: 20px;
}

.skill-orbit:nth-child(2) .skill-planet {
  background: #e3782b;
  border: 2px solid #f59958;
  color: #ffffff;
  font-size: 6px;
  line-height: 20px;
}

.skill-orbit:nth-child(3) .skill-planet {
  background: #1c6bbd;
  border: 2px solid #4484c7;
  color: #ffffff;
  font-size: 8px;
  line-height: 20px;
}

.skill-orbit:nth-child(4) .skill-planet {
  background: #3a7bbc;
  border: 2px solid #5d9cdb;
  color: #ffffff;
  font-size: 8px;
  line-height: 20px;
}

.skill-orbit:nth-child(5) .skill-planet {
  background: #74a1aa;
  border: 2px solid #a1c1c8;
  color: #ffffff;
  font-size: 6px;
  line-height: 20px;
}

.skill-orbit:nth-child(6) .skill-planet {
  background: #e7d550;
  border: 2px solid #e4d881;
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
}

.skill-orbit:nth-child(7) .skill-planet {
  background: #454f83;
  border: 2px solid #7a86c2;
  color: #ffffff;
  font-size: 8px;
  line-height: 20px;
}

.skill-orbit:nth-child(8) .skill-planet {
  background: #03d47b;
  border: 2px solid #6de9b3;
  color: #ffffff;
  font-size: 9px;
  line-height: 20px;
}

.skill-orbit:nth-child(9) .skill-planet {
  background: #e63426;
  border: 2px solid #f65246;
  color: #ffffff;
  font-size: 6px;
  line-height: 20px;
}

.skill-orbit:nth-child(10) .skill-planet {
  background: #7119e5;
  border: 2px solid #955ae1;
  color: #ffffff;
  font-size: 4px;
  line-height: 20px;
}

.skill-orbit:nth-child(11) .skill-planet {
  background: #1393d6;
  border: 2px solid #9dc7e7;
  color: #ffffff;
  font-size: 6px;
  line-height: 20px;
}

.skill-orbit:nth-child(12) .skill-planet {
  background: #52bc5f;
  border: 2px solid #80da8b;
  color: #ffffff;
  font-size: 7px;
  line-height: 20px;
}

.skill-orbit:nth-child(13) .skill-planet {
  background: #163870;
  border: 2px solid #466aa6;
  color: #ffffff;
  font-size: 7px;
  line-height: 20px;
}

.skill-orbit:nth-child(1) .skill-planet {
  -webkit-animation: travelOrbit 10s infinite linear;
  animation: travelOrbit 10s infinite linear;
  -webkit-transform-origin: 50% 650%;
  transform-origin: 50% 650%;
}

.skill-orbit:nth-child(1) span {
  -webkit-animation: unrotate 10s infinite linear;
  animation: unrotate 10s infinite linear;
}

.skill-orbit:nth-child(2) .skill-planet {
  -webkit-animation: travelOrbit 10s infinite linear;
  animation: travelOrbit 10s infinite linear;
  -webkit-transform-origin: 50% 545%;
  transform-origin: 50% 545%;
}

.skill-orbit:nth-child(2) span {
  -webkit-animation: unrotate 10s infinite linear;
  animation: unrotate 10s infinite linear;
}

.skill-orbit:nth-child(3) .skill-planet {
  -webkit-animation: travelOrbit 10s 1s infinite linear;
  animation: travelOrbit 10s 1s infinite linear;
  -webkit-transform-origin: 50% 545%;
  transform-origin: 50% 545%;
}

.skill-orbit:nth-child(3) span {
  -webkit-animation: unrotate 10s 1s infinite linear;
  animation: unrotate 10s 1s infinite linear;
}

.skill-orbit:nth-child(4) .skill-planet {
  -webkit-animation: travelOrbit 10s 2s infinite linear;
  animation: travelOrbit 10s 2s infinite linear;
  -webkit-transform-origin: 50% 545%;
  transform-origin: 50% 545%;
}

.skill-orbit:nth-child(4) span {
  -webkit-animation: unrotate 10s 2s infinite linear;
  animation: unrotate 10s 2s infinite linear;
}

.skill-orbit:nth-child(5) .skill-planet {
  -webkit-animation: travelOrbit 10s 3s infinite linear;
  animation: travelOrbit 10s 3s infinite linear;
  -webkit-transform-origin: 50% 545%;
  transform-origin: 50% 545%;
}

.skill-orbit:nth-child(5) span {
  -webkit-animation: unrotate 10s 3s infinite linear;
  animation: unrotate 10s 3s infinite linear;
}

.skill-orbit:nth-child(6) .skill-planet {
  -webkit-animation: travelOrbit 10s 4s infinite linear;
  animation: travelOrbit 10s 4s infinite linear;
  -webkit-transform-origin: 50% 545%;
  transform-origin: 50% 545%;
}

.skill-orbit:nth-child(6) span {
  -webkit-animation: unrotate 10s 4s infinite linear;
  animation: unrotate 10s 4s infinite linear;
}

.skill-orbit:nth-child(7) .skill-planet {
  -webkit-animation: travelOrbit 8s infinite linear;
  animation: travelOrbit 8s infinite linear;
  -webkit-transform-origin: 50% 445%;
  transform-origin: 50% 445%;
}

.skill-orbit:nth-child(7) span {
  -webkit-animation: unrotate 8s infinite linear;
  animation: unrotate 8s infinite linear;
}

.skill-orbit:nth-child(8) .skill-planet {
  -webkit-animation: travelOrbit 8s 1s infinite linear;
  animation: travelOrbit 8s 1s infinite linear;
  -webkit-transform-origin: 50% 445%;
  transform-origin: 50% 445%;
}

.skill-orbit:nth-child(8) span {
  -webkit-animation: unrotate 8s 1s infinite linear;
  animation: unrotate 8s 1s infinite linear;
}

.skill-orbit:nth-child(9) .skill-planet {
  -webkit-animation: travelOrbit 6s infinite linear;
  animation: travelOrbit 6s infinite linear;
  -webkit-transform-origin: 50% 335%;
  transform-origin: 50% 335%;
}

.skill-orbit:nth-child(9) span {
  -webkit-animation: unrotate 6s infinite linear;
  animation: unrotate 6s infinite linear;
}

.skill-orbit:nth-child(10) .skill-planet {
  -webkit-animation: travelOrbit 6s 1s infinite linear;
  animation: travelOrbit 6s 1s infinite linear;
  -webkit-transform-origin: 50% 335%;
  transform-origin: 50% 335%;
}

.skill-orbit:nth-child(10) span {
  -webkit-animation: unrotate 6s 1s infinite linear;
  animation: unrotate 6s 1s infinite linear;
}

.skill-orbit:nth-child(11) .skill-planet {
  -webkit-animation: travelOrbit 5s infinite linear;
  animation: travelOrbit 5s infinite linear;
  -webkit-transform-origin: 50% 225%;
  transform-origin: 50% 225%;
}

.skill-orbit:nth-child(11) span {
  -webkit-animation: unrotate 5s infinite linear;
  animation: unrotate 5s infinite linear;
}

.skill-orbit:nth-child(12) .skill-planet {
  -webkit-animation: travelOrbit 4s 1s infinite linear;
  animation: travelOrbit 4s 1s infinite linear;
  -webkit-transform-origin: 50% 225%;
  transform-origin: 50% 225%;
}

.skill-orbit:nth-child(12) span {
  -webkit-animation: unrotate 4s 1s infinite linear;
  animation: unrotate 4s 1s infinite linear;
}

.skill-orbit:nth-child(13) .skill-planet {
  -webkit-animation: travelOrbit 4s infinite linear;
  animation: travelOrbit 4s infinite linear;
  -webkit-transform-origin: 50% 225%;
  transform-origin: 50% 225%;
}

.skill-orbit:nth-child(13) span {
  -webkit-animation: unrotate 4s infinite linear;
  animation: unrotate 4s infinite linear;
}

@-webkit-keyframes travelOrbit {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes travelOrbit {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes unrotate {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(-360deg);
  }
}

@keyframes unrotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

.skills-circle:hover {
  -webkit-transform: rotate3d(60, 35, 0, 360deg);
  transform: rotate3d(60, 35, 0, 360deg);
}

li {
  list-style-type: none;
}

.logoParent {
  color: #ffffff;
}

.logoExplainLeft {
  height: 40px;
  width: 40px;
  text-align: center;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}

.logoParent:nth-child(1) .logoExplainLeft {
  background: #000000;
  border: 2px solid #0d2534;
  color: #ffffff;
  font-size: 10px;
  line-height: 40px;
}

.logoParent:nth-child(2) .logoExplainLeft {
  background: #e3782b;
  border: 2px solid #f59958;
  color: #ffffff;
  font-size: 11px;
  line-height: 40px;
}

.logoParent:nth-child(3) .logoExplainLeft {
  background: #1c6bbd;
  border: 2px solid #4484c7;
  color: #ffffff;
  font-size: 12px;
  line-height: 40px;
}

.logoParent:nth-child(4) .logoExplainLeft {
  background: #3a7bbc;
  border: 2px solid #5d9cdb;
  color: #ffffff;
  font-size: 15px;
  line-height: 40px;
}

.logoParent:nth-child(5) .logoExplainLeft {
  background: #74a1aa;
  border: 2px solid #a1c1c8;
  color: #ffffff;
  font-size: 10px;
  line-height: 40px;
}

.logoParent:nth-child(6) .logoExplainLeft {
  background: #e7d550;
  border: 2px solid #e4d881;
  color: #ffffff;
  font-size: 18px;
  line-height: 40px;
}

.logoParent:nth-child(7) .logoExplainLeft {
  background: #454f83;
  border: 2px solid #7a86c2;
  color: #ffffff;
  font-size: 11px;
  line-height: 40px;
}

.logoParent:nth-child(8) .logoExplainLeft {
  background: #03d47b;
  border: 2px solid #6de9b3;
  color: #000000;
  font-size: 15px;
  line-height: 40px;
}

.logoParent:nth-child(9) .logoExplainLeft {
  background: #e63426;
  border: 2px solid #f65246;
  color: #ffffff;
  font-size: 10px;
  line-height: 40px;
}

.logoParent:nth-child(10) .logoExplainLeft {
  background: #7119e5;
  border: 2px solid #955ae1;
  color: #ffffff;
  font-size: 8px;
  line-height: 40px;
}

.logoParent:nth-child(11) .logoExplainLeft {
  background: #1393d6;
  border: 2px solid #9dc7e7;
  color: #ffffff;
  font-size: 9px;
  line-height: 40px;
}

.logoParent:nth-child(12) .logoExplainLeft {
  background: #52bc5f;
  border: 2px solid #80da8b;
  color: #ffffff;
  font-size: 11px;
  line-height: 40px;
}

.logoParent:nth-child(13) .logoExplainLeft {
  background: #163870;
  border: 2px solid #466aa6;
  color: #ffffff;
  font-size: 11px;
  line-height: 40px;
}
</style>

<script>
export default {
  name: "ListSkill",
  data: () => ({
    skill: [
      //   Platform / Repository
      { name: "Github", explain: "Competent Programmer" },
      //   Platform / Repository
      //  Markup Language
      { name: "HTML", explain: "Competent Programmer" },
      { name: "CSS", explain: "Competent Programmer" },
      //  Markup Language
      //   Database Software and Database Language
      { name: "SQL", explain: "Competent Programmer" },
      { name: "MySQL", explain: "Competent Programmer" },
      //   Database Software and Database Language
      //   Programming Language
      { name: "JS", explain: "Advance Beginner Programmer" },
      { name: "PHP", explain: "Competent Programmer" },
      //   Programming Language
      //   Library
      { name: "Nuxt", explain: "Novice Programmer" },
      { name: "Laravel", explain: "Novice Programmer" },
      { name: "Bootstrap", explain: "Competent Programmer" },
      { name: "Vuetify", explain: "Advance Beginner Programmer" },
      { name: "Vue.js", explain: "Advance Beginner Programmer" },
      { name: "Jquery", explain: "Competent Programmer" },
      //   Library
    ],
  }),
};
</script>
